import React from 'react';

// reference: https://designportal.microsoft.com/media/?resetsearch=&field=metaproperty_Asset_Type&value=Illustrations&viewType=grid#
export const MicrosoftAccount = (props) => (
  <svg viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M256 369C318.408 369 369 318.408 369 256L439 256C439 357.068 357.068 439 256 439C236.67 439 221 423.33 221 404C221 384.67 236.67 369 256 369Z"
      fill="url(#paint0_radial_7761_8192)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M256 369C318.408 369 369 318.408 369 256L439 256C439 357.068 357.068 439 256 439C236.67 439 221 423.33 221 404C221 384.67 236.67 369 256 369Z"
      fill="url(#paint1_radial_7761_8192)"
      fillOpacity="0.9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M256 369C318.408 369 369 318.408 369 256L439 256C439 357.068 357.068 439 256 439C236.67 439 221 423.33 221 404C221 384.67 236.67 369 256 369Z"
      fill="url(#paint2_radial_7761_8192)"
      fillOpacity="0.7"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M256 369C318.408 369 369 318.408 369 256L439 256C439 357.068 357.068 439 256 439C236.67 439 221 423.33 221 404C221 384.67 236.67 369 256 369Z"
      fill="url(#paint3_radial_7761_8192)"
    />
    <path
      d="M255.971 369C193.576 368.984 143 318.399 143 256C143 236.67 127.33 221 108 221C88.67 221 73 236.67 73 256C73 357.068 154.932 439 256 439C236.67 439 221 423.33 221 404C221 384.68 236.654 369.016 255.971 369Z"
      fill="url(#paint4_radial_7761_8192)"
    />
    <path
      d="M255.971 369C193.576 368.984 143 318.399 143 256C143 236.67 127.33 221 108 221C88.67 221 73 236.67 73 256C73 357.068 154.932 439 256 439C236.67 439 221 423.33 221 404C221 384.68 236.654 369.016 255.971 369Z"
      fill="url(#paint5_radial_7761_8192)"
    />
    <path
      d="M255.971 369C193.576 368.984 143 318.399 143 256C143 236.67 127.33 221 108 221C88.67 221 73 236.67 73 256C73 357.068 154.932 439 256 439C236.67 439 221 423.33 221 404C221 384.68 236.654 369.016 255.971 369Z"
      fill="url(#paint6_radial_7761_8192)"
    />
    <path
      d="M255.971 369C193.576 368.984 143 318.399 143 256C143 236.67 127.33 221 108 221C88.67 221 73 236.67 73 256C73 357.068 154.932 439 256 439C236.67 439 221 423.33 221 404C221 384.68 236.654 369.016 255.971 369Z"
      fill="url(#paint7_radial_7761_8192)"
      fillOpacity="0.8"
    />
    <path
      d="M255.971 369C193.576 368.984 143 318.399 143 256C143 236.67 127.33 221 108 221C88.67 221 73 236.67 73 256C73 357.068 154.932 439 256 439C236.67 439 221 423.33 221 404C221 384.68 236.654 369.016 255.971 369Z"
      fill="url(#paint8_radial_7761_8192)"
    />
    <path
      d="M255.971 369C193.576 368.984 143 318.399 143 256C143 236.67 127.33 221 108 221C88.67 221 73 236.67 73 256C73 357.068 154.932 439 256 439C236.67 439 221 423.33 221 404C221 384.68 236.654 369.016 255.971 369Z"
      fill="url(#paint9_radial_7761_8192)"
      fillOpacity="0.8"
    />
    <path
      d="M255.971 369C193.576 368.984 143 318.399 143 256C143 236.67 127.33 221 108 221C88.67 221 73 236.67 73 256C73 357.068 154.932 439 256 439C236.67 439 221 423.33 221 404C221 384.68 236.654 369.016 255.971 369Z"
      fill="url(#paint10_radial_7761_8192)"
    />
    <path
      d="M255.971 369C193.576 368.984 143 318.399 143 256C143 236.67 127.33 221 108 221C88.67 221 73 236.67 73 256C73 357.068 154.932 439 256 439C236.67 439 221 423.33 221 404C221 384.68 236.654 369.016 255.971 369Z"
      fill="url(#paint11_radial_7761_8192)"
      fillOpacity="0.8"
    />
    <path
      d="M255.971 369C193.576 368.984 143 318.399 143 256C143 236.67 127.33 221 108 221C88.67 221 73 236.67 73 256C73 357.068 154.932 439 256 439C236.67 439 221 423.33 221 404C221 384.68 236.654 369.016 255.971 369Z"
      fill="url(#paint12_radial_7761_8192)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M369 256C369 193.592 318.408 143 256 143L256 73C357.068 73 439 154.932 439 256C439 275.33 423.33 291 404 291C384.67 291 369 275.33 369 256Z"
      fill="url(#paint13_linear_7761_8192)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M369 256C369 193.592 318.408 143 256 143L256 73C357.068 73 439 154.932 439 256C439 275.33 423.33 291 404 291C384.67 291 369 275.33 369 256Z"
      fill="url(#paint14_radial_7761_8192)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M369 256C369 193.592 318.408 143 256 143L256 73C357.068 73 439 154.932 439 256C439 275.33 423.33 291 404 291C384.67 291 369 275.33 369 256Z"
      fill="url(#paint15_radial_7761_8192)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M369 256C369 193.592 318.408 143 256 143L256 73C357.068 73 439 154.932 439 256C439 275.33 423.33 291 404 291C384.67 291 369 275.33 369 256Z"
      fill="url(#paint16_radial_7761_8192)"
      fillOpacity="0.8"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M369 256C369 193.592 318.408 143 256 143L256 73C357.068 73 439 154.932 439 256C439 275.33 423.33 291 404 291C384.67 291 369 275.33 369 256Z"
      fill="url(#paint17_radial_7761_8192)"
    />
    <path
      d="M143 256C143 193.592 193.592 143 256 143C275.33 143 291 127.33 291 108C291 88.67 275.33 73 256 73C154.932 73 73 154.932 73 256C73 236.67 88.67 221 108 221C127.33 221 143 236.67 143 256Z"
      fill="url(#paint18_radial_7761_8192)"
    />
    <path
      d="M143 256C143 193.592 193.592 143 256 143C275.33 143 291 127.33 291 108C291 88.67 275.33 73 256 73C154.932 73 73 154.932 73 256C73 236.67 88.67 221 108 221C127.33 221 143 236.67 143 256Z"
      fill="url(#paint19_radial_7761_8192)"
      fillOpacity="0.9"
    />
    <path
      d="M143 256C143 193.592 193.592 143 256 143C275.33 143 291 127.33 291 108C291 88.67 275.33 73 256 73C154.932 73 73 154.932 73 256C73 236.67 88.67 221 108 221C127.33 221 143 236.67 143 256Z"
      fill="url(#paint20_radial_7761_8192)"
      fillOpacity="0.9"
    />
    <circle cx="255" cy="108" r="26" fill="url(#paint21_radial_7761_8192)" />
    <circle cx="404" cy="255" r="26" fill="url(#paint22_radial_7761_8192)" />
    <circle cx="108" cy="258" r="26" fill="url(#paint23_radial_7761_8192)" />
    <circle cx="256" cy="404" r="26" fill="url(#paint24_radial_7761_8192)" />
    <path
      d="M212.801 270C204.274 270 197.357 276.96 197.357 285.555L197.357 288.304C197.357 302.053 204.413 312.345 215.237 318.983C225.88 325.511 240.187 328.574 255.5 328.574C270.813 328.574 285.12 325.511 295.764 318.983C306.587 312.345 313.643 302.053 313.643 288.304L313.643 285.554C313.643 276.96 306.727 270 298.2 270H212.801Z"
      fill="url(#paint25_radial_7761_8192)"
    />
    <path
      d="M212.801 270C204.274 270 197.357 276.96 197.357 285.555L197.357 288.304C197.357 302.053 204.413 312.345 215.237 318.983C225.88 325.511 240.187 328.574 255.5 328.574C270.813 328.574 285.12 325.511 295.764 318.983C306.587 312.345 313.643 302.053 313.643 288.304L313.643 285.554C313.643 276.96 306.727 270 298.2 270H212.801Z"
      fill="url(#paint26_radial_7761_8192)"
      fillOpacity="0.4"
    />
    <circle
      cx="255.499"
      cy="219.348"
      r="36.3482"
      fill="url(#paint27_radial_7761_8192)"
    />
    <circle
      cx="255.499"
      cy="219.348"
      r="36.3482"
      fill="url(#paint28_radial_7761_8192)"
      fillOpacity="0.8"
    />
    <circle cx="257.5" cy="195.5" r="1.5" fill="#E2FFC9" />
    <circle cx="288.5" cy="297.5" r="1.5" fill="#E2FFC9" />
    <ellipse cx="272" cy="192.5" rx="1" ry="1.5" fill="#E2FFC9" />
    <ellipse cx="277" cy="278.5" rx="2" ry="1.5" fill="#E2FFC9" />
    <circle cx="280.5" cy="235.5" r="1.5" fill="#E2FFC9" />
    <defs>
      <radialGradient
        id="paint0_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(261 406) rotate(-54.6763) scale(155.657 155.657)"
      >
        <stop offset="0.275464" stopColor="#FFCE1F" />
        <stop offset="0.580421" stopColor="#EFDFA8" />
        <stop offset="1" stopColor="#E7E7E7" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(265.5 327.5) rotate(52.1536) scale(88.0128 96.4717)"
      >
        <stop offset="0.721955" stopColor="#DCA200" />
        <stop offset="1" stopColor="#FFCE20" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(244.5 425.5) rotate(26.5651) scale(32.423 59.5739)"
      >
        <stop offset="0.137931" stopColor="#9C3600" />
        <stop offset="0.624215" stopColor="#A96500" />
        <stop offset="0.862069" stopColor="#FFCE20" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(403 266) rotate(-158.532) scale(47.8174 84.6816)"
      >
        <stop offset="0.562494" stopColor="#D0D0D0" />
        <stop offset="0.918047" stopColor="#E7E7E7" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(57 266.5) rotate(44.5225) scale(254.567 318.371)"
      >
        <stop offset="0.245162" stopColor="#0083EE" />
        <stop offset="0.463346" stopColor="#5EC5FF" />
        <stop offset="0.715684" stopColor="#D1E1EB" />
        <stop offset="0.879789" stopColor="#E7E7E7" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(246.5 235.5) rotate(144.782) scale(197.682 144.622)"
      >
        <stop offset="0.650176" stopColor="#0657B4" />
        <stop offset="0.780114" stopColor="#1491F2" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(119 190) rotate(96.2419) scale(96.5725 73.5671)"
      >
        <stop offset="0.747027" stopColor="#0758B4" />
        <stop offset="0.933816" stopColor="#0758B4" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(101.25 274.25) rotate(15.0184) scale(31.8375 59.5047)"
      >
        <stop offset="0.115427" stopColor="#002686" />
        <stop offset="0.696144" stopColor="#0055B1" />
        <stop offset="0.857303" stopColor="#0481EA" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(61.5 245) rotate(48.4912) scale(267.075 334.013)"
      >
        <stop offset="0.245162" stopColor="#0083EE" />
        <stop offset="0.463346" stopColor="#5EC5FF" />
        <stop offset="0.75945" stopColor="#E7E7E7" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(246.5 235.5) rotate(144.782) scale(197.682 144.622)"
      >
        <stop offset="0.650176" stopColor="#0657B4" />
        <stop offset="0.780114" stopColor="#5CC3FE" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(119 190) rotate(96.2419) scale(96.5725 73.5671)"
      >
        <stop offset="0.747027" stopColor="#0758B4" />
        <stop offset="0.933816" stopColor="#0758B4" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint11_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(101.25 274.25) rotate(15.0184) scale(31.8375 59.5047)"
      >
        <stop offset="0.115427" stopColor="#002686" />
        <stop offset="0.696144" stopColor="#0055B1" />
        <stop offset="0.857303" stopColor="#0481EA" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(239 427) rotate(-163.244) scale(48.5618 64.3828)"
      >
        <stop offset="0.562494" stopColor="#D0D0D0" />
        <stop offset="0.871878" stopColor="#E7E7E7" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint13_linear_7761_8192"
        x1="330"
        y1="121"
        x2="410"
        y2="291"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E7E7E7" />
        <stop offset="0.342351" stopColor="#EEFFA6" />
        <stop offset="0.667062" stopColor="#AAD81F" />
      </linearGradient>
      <radialGradient
        id="paint14_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(473.5 147.5) rotate(153.122) scale(122.762 192.924)"
      >
        <stop offset="0.643525" stopColor="#8BC226" />
        <stop offset="0.889221" stopColor="#CDEC65" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint15_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(437.5 266.5) rotate(-155.019) scale(24.2706 27.8113)"
      >
        <stop offset="0.405" stopColor="#8BC226" />
        <stop offset="1" stopColor="#A7D534" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint16_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(395.5 276.5) rotate(-169.846) scale(34.0331 30.9561)"
      >
        <stop offset="0.095" stopColor="#233F00" />
        <stop offset="0.624215" stopColor="#3B7A00" />
        <stop offset="0.797835" stopColor="#AAD820" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint17_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(245.5 115.5) rotate(27.1124) scale(70.2157 50.9883)"
      >
        <stop offset="0.622687" stopColor="#D0D0D0" />
        <stop offset="0.871878" stopColor="#E7E7E7" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint18_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(119.5 248) rotate(-45.1121) scale(180.666 240.032)"
      >
        <stop offset="0.189942" stopColor="#E7E7E7" />
        <stop offset="0.530488" stopColor="#EEC7B7" />
        <stop offset="0.943344" stopColor="#FF5C39" />
      </radialGradient>
      <radialGradient
        id="paint19_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(248 128) rotate(41.2686) scale(32.596 50.4316)"
      >
        <stop offset="0.574387" stopColor="#A31400" />
        <stop offset="0.890515" stopColor="#F98C57" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint20_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(199.5 43.5) rotate(-72.646) scale(83.8153 159.967)"
      >
        <stop offset="0.652068" stopColor="#BC272B" />
        <stop offset="1" stopColor="#F89760" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint21_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(259.917 96.0846) rotate(108.435) scale(47.7984)"
      >
        <stop stopColor="white" />
        <stop offset="0.25" stopColor="#FFEFDA" />
        <stop offset="0.645065" stopColor="#C9B08F" />
        <stop offset="0.831818" stopColor="#E2D5C3" />
      </radialGradient>
      <radialGradient
        id="paint22_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(408.917 243.085) rotate(108.435) scale(47.7984)"
      >
        <stop stopColor="white" />
        <stop offset="0.25" stopColor="#FFEFDA" />
        <stop offset="0.645065" stopColor="#C9B08F" />
        <stop offset="0.831818" stopColor="#E2D5C3" />
      </radialGradient>
      <radialGradient
        id="paint23_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(112.917 246.085) rotate(108.435) scale(47.7984)"
      >
        <stop stopColor="white" />
        <stop offset="0.25" stopColor="#FFEFDA" />
        <stop offset="0.645065" stopColor="#C9B08F" />
        <stop offset="0.831818" stopColor="#E2D5C3" />
      </radialGradient>
      <radialGradient
        id="paint24_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(260.917 392.085) rotate(108.435) scale(47.7984)"
      >
        <stop stopColor="white" />
        <stop offset="0.25" stopColor="#FFEFDA" />
        <stop offset="0.645065" stopColor="#C9B08F" />
        <stop offset="0.831818" stopColor="#E2D5C3" />
      </radialGradient>
      <radialGradient
        id="paint25_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(263.423 261.081) rotate(88.7727) scale(86.3415 125.86)"
      >
        <stop offset="0.103226" stopColor="#C594FF" />
        <stop offset="0.540245" stopColor="#AD6CFF" />
        <stop offset="0.625" stopColor="#9951FF" />
        <stop offset="0.713562" stopColor="#8E42FF" />
        <stop offset="0.8057" stopColor="#D977BB" />
      </radialGradient>
      <radialGradient
        id="paint26_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(279.283 270) rotate(90) scale(22.5852 146.283)"
      >
        <stop offset="0.376041" stopColor="#FDF7FF" />
        <stop offset="1" stopColor="#F0C3FF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint27_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(263.294 203.657) rotate(120.18) scale(74.4406)"
      >
        <stop offset="0.05" stopColor="#E8CCFF" />
        <stop offset="0.23" stopColor="#C594FF" />
        <stop offset="0.36" stopColor="#AD6CFF" />
        <stop offset="0.51" stopColor="#8E42FF" />
        <stop offset="0.78" stopColor="#E0538F" />
      </radialGradient>
      <radialGradient
        id="paint28_radial_7761_8192"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(255.496 219.378) rotate(97.82) scale(64.5261)"
      >
        <stop offset="0.45" stopColor="white" stopOpacity="0" />
        <stop offset="0.84" stopColor="white" />
      </radialGradient>
    </defs>
  </svg>
);

MicrosoftAccount.displayName = 'MicrosoftAccount';
